"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBakeTitle = void 0;
var NON_CAPITALIZE_WORDS = ['a', 'an', 'the', 'and', 'but', 'if', 'for', 'or', 'nor', 'at', 'by', 'from', 'in', 'into', 'of', 'on', 'over', 'to', 'with'];
var getBakeTitle = function getBakeTitle(text) {
  return text.split(' ').map(function (txt, index) {
    return txt === txt.toUpperCase() ? txt : NON_CAPITALIZE_WORDS.indexOf(txt.toLowerCase()) > -1 && index !== 0 ? txt.toLowerCase() : txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();
  }).join(' ');
};
exports.getBakeTitle = getBakeTitle;